import { useMemo } from "react";

import { isGeometryType } from "../../../../../evergis/core/attributes/attributes";
import { LayerAttribute } from "../../../EditResource/components/Layer/LayerAttributeItem";
import { TableAttribute } from "../../../EditResource/components/Table/TableAttributeItem";
import { ImportAttribute } from "../../../Import/types";
import { UploadAttribute } from "../../../UploadData/types";

export type Attribute = (TableAttribute | LayerAttribute | ImportAttribute | UploadAttribute) & {
  deleted?: boolean;
  private?: boolean;
  expression?: string;
};

export const useAttributesToRender = (attributes: Attribute[]): Attribute[] =>
  useMemo(() => {
    return attributes
      ? attributes.filter(
          ({ type, deleted, expression, ...rest }) =>
            (!isGeometryType(type) || !!expression) && !deleted && !rest.private,
        )
      : [];
  }, [attributes]);
